import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/version/admin/versions`;

const parseJsonResponse = async (response) => {
  if (!response) {
    throw new Error("No se recibió respuesta del servidor");
  }

  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json")
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    const message =
      payload?.error ||
      payload?.message ||
      (typeof payload === "string" && payload) ||
      `Error ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
};

export const fetchVersions = async (navigate) => {
  const response = await fetchWithAuth(
    API_URL,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
    navigate
  );

  return parseJsonResponse(response);
};

export const createVersion = async (data, navigate) => {
  const response = await fetchWithAuth(
    API_URL,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    },
    navigate
  );

  return parseJsonResponse(response);
};

export const updateVersion = async (id, data, navigate) => {
  const response = await fetchWithAuth(
    `${API_URL}/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    },
    navigate
  );

  return parseJsonResponse(response);
};

export const patchVersionStatus = async (id, status, navigate) => {
  const response = await fetchWithAuth(
    `${API_URL}/${id}/status`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status }),
    },
    navigate
  );

  return parseJsonResponse(response);
};
